import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "csr00200-search-form" }
const _hoisted_2 = { class: "row q-mb-sm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "csr00200-supplier" }
const _hoisted_7 = { class: "row justify-end q-mt-md q-gutter-xs" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import KeySearchForm from '../components/form/KeySearchForm.vue';
import StructureSearchForm from '../components/form/StructureSearchForm.vue';
import StructureConditionsForm from '../components/form/StructureConditionsForm.vue';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import CategoryCheckBox from '../components/checkBox/CategoryCheckBox.vue';
import SupplierSelectsUseInput from '../components/selects/SupplierSelectsUseInput.vue';
import SearchResultList from '../components/list/SearchResultList.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import http from '../common/axios-common';
import replaceFullToHalf from '../common/utils/stringUtils';
import { getMarvin, clearMarvin } from '../common/marvin-js';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../common/code/ResultStatusCode';
import messages from '../messages/message.json';
import { isFileExist } from '../common/utils/fileUtils';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';

interface Props {
  // タイプ（キー検索:0[デフォルト値], 構造検索:1）
  type: string;
  // カテゴリー(試薬:1[デフォルト値])
  supCategory: number;
}

const KEY = '0';

// 構造検索
const STRUCTUAL = '1';

// 試薬
const REAGENT = 1;

// 開閉
interface Supplier {
  label: string;
  value: string;
}

// サプライヤ
interface KeyPullDown {
  label: string;
  value: string;
}

// 詳細検索項目
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

// 検索条件
interface Conditions {
  condition_id: number;
  condition_number: number;
  symbolic_query: string;
  symbolic_query_type: string;
  querysearchResultCount: number;
}

// 検索結果情報
interface SearchResultInfo {
  searchResultConditionsDto: Conditions;
  searchResultDetailList: Array<Result>;
}

// 検索Response
interface SearchResponse {
  attoIdList: Array<string>;
  searchResultInfo: Array<SearchResultInfo>;
  searchMaxCount: number;
}

// 検索結果

export default /*@__PURE__*/_defineComponent({
  __name: 'CSR00200',
  props: {
    type: { default: '0' },
    supCategory: { default: 1 }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

// キー検索
const openFlg = ref<boolean>(true);

// 検索結果
const searchFlg = ref<boolean>(false);

// サプライヤInterface
const suppliers = ref<Supplier[]>([]);

// カテゴリー
const categories = ref<number[]>([]);

// 試薬フラグ
const reagentFlg = ref<boolean>(true);

// フリーワード
const freeWord = ref<string>('');

// 詳細検索キー
const keyData = ref<KeyPullDown>({ label: '', value: '' });

// 詳細検索値
const keyValue = ref<string>('');

// 完全一致
const completeMatch = ref<boolean>(true);

// 検索可能フラグ
const searchableFlg = ref<boolean>(true);

// 検索結果要素
const searchResultElement = ref<HTMLImageElement>();

// 検索結果上限超過フラグ
const resultOverFlg = ref<boolean>(false);

// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);

// ダイアログタイトル
const dialogTitle = ref<string>('');

// Dialog表示レベル
const dialogLevel = ref('');

// Marvin Editor FLG
const editorFlg = ref<boolean>(true);

// SDFファイル
const sdfFile = ref<File>();

// 検索タイプ
const searchType = ref<string>('partial');

// E/Z一致
const ez = ref<boolean>(true);

// Chiral一致
const chiral = ref<boolean>(true);

// Tautomer
const tautomer = ref<boolean>(false);

// 閾値
const threshold = ref<number>(70);

// ダイアログ閉じる
const closeDialog = () => {
  resultOverFlg.value = false;
  setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
};

// 検索結果
const searchResult = ref<SearchResponse>({
  attoIdList: [],
  searchResultInfo: [],
  searchMaxCount: 0,
});

// カテゴリー初期値設定
const initCategory = () => {
  // カテゴリー設定
  categories.value.push(Number(props.supCategory));
  // カテゴリーが試薬の場合
  if (props.supCategory === REAGENT) {
    reagentFlg.value = true;
  } else {
    reagentFlg.value = false;
  }
};

// カテゴリー変更
const changeCategory = (value: number[]) => {
  categories.value = value;
};

// フリーワードクリア
const clearFreeWord = () => {
  freeWord.value = '';
};

// 詳細条件クリア
const clearKeySearch = () => {
  keyData.value = { label: '', value: '' };
  keyValue.value = '';
  completeMatch.value = true;
};

// 詳細条件のkey変更
const changeKeyData = (value: KeyPullDown) => {
  keyData.value = value;
  if (keyData.value && keyData.value.label !== '化学名') {
    completeMatch.value = true;
  }
};

// キー検索条件クリア
const keySearchClear = () => {
  suppliers.value = [];
  categories.value = [];
  initCategory();
  freeWord.value = '';
  keyData.value = { label: '', value: '' };
  keyValue.value = '';
  completeMatch.value = true;
  searchFlg.value = false;
};

// 検索件数上限超過チェック
const checkOverResult = () => {
  if (searchResult.value.searchMaxCount === Number(messages.ja.validation.search_max_count)) {
    dialogText.value = [
      `先頭から${messages.ja.validation.search_max_count}件までの検索結果を表示しています。`,
      'お探しの化合物が見つからない場合、検索条件を絞り込んで再度検索してください。',
    ];
    dialogTitle.value = '検索結果上限値超過';
    resultOverFlg.value = true;
  }
};

// キー検索
const keySearch = () => {
  let arr: string[] = [];
  let fixArr: string[] = [];

  if (keyValue.value.match(/[']/) && keyData.value.value === 'SMILES') {
    dialogTitle.value = '検索条件入力エラー';
    dialogText.value = ["SMILESで検索時には「'」を入力しないでください。"];
    searchableFlg.value = false;
  }

  // 詳細検索入力内容リストに整形
  if (keyValue.value !== '') {
    // 全角から半角へ変換
    let str = replaceFullToHalf(keyValue.value);
    str = str.replaceAll(/[ー]/g, '-');
    arr = str.split('\n');
    // ブランク削除
    arr.forEach((element) => {
      str = element.trim();
      if (str) {
        fixArr.push(str);
      }
    });
    fixArr = fixArr.filter((v) => !''.includes(v));
  }

  // 必須項目が入力されていない場合
  if (
    categories.value.length === 0 ||
    (freeWord.value.trim() === '' && (keyData.value.value === '' || fixArr.length === 0))
  ) {
    dialogTitle.value = '検索条件入力エラー';
    dialogText.value = [
      'カテゴリーを１つ以上選択し、簡易検索もしくは詳細検索条件を入力してください。',
    ];
    searchableFlg.value = false;
  }

  // 詳細検索テキストチェック
  if (fixArr.length > Number(messages.ja.validation.search_max_count)) {
    dialogTitle.value = '検索条件入力エラー';
    dialogText.value = [
      `詳細検索条件が${messages.ja.validation.search_max_count}行を超えています。`,
      `${messages.ja.validation.search_max_count}行以内で入力してください。`,
    ];
    searchableFlg.value = false;
  }

  // 簡易検索条件、詳細検索条件の両方入力されている場合
  if (freeWord.value !== '' && (keyData.value.value !== '' || fixArr.length !== 0)) {
    dialogTitle.value = '検索条件入力エラー';
    dialogText.value = ['検索条件は簡易検索・詳細検索のいずれかを入力してください。'];
    searchableFlg.value = false;
  }

  if (searchableFlg.value) {
    // Loading Start
    Loading.show();
    searchFlg.value = false;

    // バックエンドへ渡すパラメータ設定
    const formData = new FormData();
    formData.append('query', freeWord.value);
    formData.append('conditionType', keyData.value.value);
    fixArr.forEach((query) => formData.append('queries', query));

    if (completeMatch.value) {
      formData.append('completeMatch', 'true');
    } else {
      formData.append('completeMatch', 'false');
    }
    if (freeWord.value !== '') {
      formData.append('type', 'TEXT');
    } else {
      formData.append('type', 'BULK');
    }
    categories.value.forEach((category) =>
      formData.append('sup_category_ids', category.toString())
    );
    suppliers.value.forEach((supplier: { label: string; value: string }) => {
      formData.append('supplier_ids', supplier.value);
    });
    // 検索
    http
      .post('/csr002001/simpleSearch', formData)
      .then((response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          if (response.data.common.detail_status === DetailResultStatusCode.STATEMENT_TIMEOUT) {
            dialogTitle.value = '検索時間超過エラー';
            dialogText.value = [`検索時間が上限に達しました。条件を見直して再検索してください。`];
            searchableFlg.value = false;
          } else {
            // エラー画面遷移
            router.push({ name: 'error' });
          }
        } else {
          searchFlg.value = true;
          searchResult.value = response.data;
          if (Number(categories.value[0]) === REAGENT) {
            reagentFlg.value = true;
          } else {
            reagentFlg.value = false;
          }
          checkOverResult();
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          // その他エラーの場合
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
        // スクロール
        setTimeout(() => searchResultElement.value?.scrollIntoView(true), 800);
      });
  }
};

// 構造検索
const structureSearch = () => {
  getMarvin().then(async (structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
      searchableFlg.value = false;
    }
    // 必須項目が入力されていない場合
    if (
      categories.value.length === 0 ||
      (structure === undefined && editorFlg.value) ||
      (sdfFile.value === undefined && !editorFlg.value)
    ) {
      dialogTitle.value = '検索条件入力エラー';
      if (editorFlg.value) {
        dialogText.value = ['カテゴリーを１つ以上選択し、構造式を入力してください。'];
      }
      if (!editorFlg.value) {
        dialogText.value = ['カテゴリーを１つ以上選択し、SDFileをアップロードしてください。'];
      }
      searchableFlg.value = false;
    }

    // SDF読み込みエラー
    if (sdfFile.value) {
      await isFileExist(sdfFile.value).then((value) => {
        if (!value) {
          dialogTitle.value = 'ファイル読み込みエラー';
          dialogLevel.value = 'error';
          if (sdfFile.value !== undefined && sdfFile.value.size === 0) {
            dialogText.value = [
              '選択したファイルは内容が設定されていません。',
              'ファイルを再度選択してください。',
            ];
          } else {
            dialogText.value = [
              '更新または削除されたファイルがあるため、アップロードできませんでした。',
              'ファイルを再度選択してください。',
            ];
          }
          searchableFlg.value = false;
        }
      });
    }

    // 閾値入力範囲チェック
    if (threshold.value < 1 || (threshold.value > 100 && searchType.value === 'similar')) {
      dialogTitle.value = '検索条件入力エラー';
      dialogText.value = ['類似率は1～100の整数値で入力してください。'];
      searchableFlg.value = false;
    }

    // 構造式もしくはSDFが選択されている場合
    if (searchableFlg.value) {
      // Loading Start
      Loading.show();
      searchFlg.value = false;

      const formData = new FormData();
      if (ez.value) {
        formData.append('ez', 'true');
      } else {
        formData.append('ez', 'false');
      }
      if (chiral.value) {
        formData.append('chiral', 'true');
      } else {
        formData.append('chiral', 'false');
      }
      if (tautomer.value) {
        formData.append('tautomer', 'true');
      } else {
        formData.append('tautomer', 'false');
      }
      formData.append('threshold', String(threshold.value / 100));
      formData.append('searchType', searchType.value);
      formData.append('type', 'STRUCTURE');
      if (structure !== undefined && editorFlg.value) {
        formData.append('structure', structure);
        formData.append('extension', 'STRUCTURE');
      }
      if (sdfFile.value !== undefined && !editorFlg.value) {
        formData.append('sdfFile', sdfFile.value);
        formData.append('extension', 'SDF');
      }
      categories.value.forEach((category) =>
        formData.append('sup_category_ids', category.toString())
      );
      suppliers.value.forEach((supplier: { label: string; value: string }) => {
        formData.append('supplier_ids', supplier.value);
      });
      // 検索
      http
        .post('/csr002002/structureSerach', formData)
        .then((response) => {
          if (response.data.common.status === ResultStatusCode.ERROR) {
            if (response.data.common.detail_status === DetailResultStatusCode.MAX_MOL_ERROR) {
              dialogTitle.value = '検索条件入力エラー';
              dialogText.value = [
                `SDFile内の化合物が${messages.ja.validation.search_max_count}件を超えています。`,
                `SDFile内の件数を${messages.ja.validation.search_max_count}件以内にして検索してください。`,
              ];
              searchableFlg.value = false;
            } else if (
              response.data.common.detail_status === DetailResultStatusCode.STATEMENT_TIMEOUT
            ) {
              dialogTitle.value = '検索時間超過エラー';
              dialogText.value = [`検索時間が上限に達しました。条件を見直して再検索してください。`];
              searchableFlg.value = false;
            } else if (
              response.data.common.detail_status === DetailResultStatusCode.PARAMETER_ERROR
            ) {
              dialogTitle.value = '検索条件入力エラー';
              dialogText.value = [
                'SDFileが不正です。',
                `カテゴリーを１つ以上選択し、正しいSDFileをアップロードしてください。`,
              ];
              searchableFlg.value = false;
            } else {
              // エラー画面遷移
              router.push({ name: 'error' });
            }
          } else {
            searchFlg.value = true;
            searchResult.value = response.data;
            if (Number(categories.value[0]) === REAGENT) {
              reagentFlg.value = true;
            } else {
              reagentFlg.value = false;
            }
            checkOverResult();
          }
        })
        .catch((err) => {
          if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
            // セッションタイムアウトの場合
            router.push({ name: 'login', query: { timeout: 'timeout' } });
          } else {
            // その他エラーの場合
            router.push({ name: 'error' });
          }
        })
        .finally(() => {
          // Loading End
          Loading.hide();
          // スクロール
          setTimeout(() => searchResultElement.value?.scrollIntoView(true), 800);
        });
    }
  });
};

// 構造検索条件クリア
const structureSearchClear = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
      searchableFlg.value = false;
    }
  });
  suppliers.value = [];
  categories.value = [];
  initCategory();
  searchType.value = 'partial';
  sdfFile.value = undefined;
  ez.value = true;
  chiral.value = true;
  tautomer.value = false;
  threshold.value = 70;
  searchFlg.value = false;
};

// 検索結果表示
const conditionAreaOpen = () => {
  if (openFlg.value) {
    openFlg.value = false;
  } else {
    openFlg.value = true;
  }
};

// 初期表示処理
initCategory();

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      "title-toggle": _withCtx(() => [
        _createVNode(_component_q_btn_toggle, {
          "model-value": _ctx.type,
          flat: "",
          dense: "",
          size: "1.6rem",
          "text-color": "grey-7",
          "toggle-color": "primary",
          options: [
            { label: 'キー検索', value: KEY },
            { label: '構造検索', value: STRUCTUAL },
          ],
          class: "page-toggle",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = 
            (value) => {
              _unref(router).replace({
                name: 'search',
                params: { type: value, supCategory: props.supCategory },
              });
            }
          )
        }, null, 8, ["model-value", "options"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_expansion_item, {
      modelValue: openFlg.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((openFlg).value = $event)),
      "header-style": "display:none"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CategoryCheckBox, {
              categories: categories.value,
              "onUpdate:categories": _cache[1] || (_cache[1] = ($event: any) => ((categories).value = $event)),
              class: "q-mb-md",
              onChange: changeCategory
            }, null, 8, ["categories"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.type === KEY)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(KeySearchForm, {
                    freeWord: freeWord.value,
                    "onUpdate:freeWord": _cache[2] || (_cache[2] = ($event: any) => ((freeWord).value = $event)),
                    keyData: keyData.value,
                    "onUpdate:keyData": _cache[3] || (_cache[3] = ($event: any) => ((keyData).value = $event)),
                    keyValue: keyValue.value,
                    "onUpdate:keyValue": _cache[4] || (_cache[4] = ($event: any) => ((keyValue).value = $event)),
                    completeMatch: completeMatch.value,
                    "onUpdate:completeMatch": _cache[5] || (_cache[5] = ($event: any) => ((completeMatch).value = $event)),
                    onClearFreeWord: clearFreeWord,
                    onClearKeySearch: clearKeySearch,
                    onChangeFreeWord: _cache[6] || (_cache[6] = ($event: any) => (freeWord.value = $event)),
                    onChangeKeyData: changeKeyData,
                    onChangeKeyValue: _cache[7] || (_cache[7] = ($event: any) => (keyValue.value = $event)),
                    onChangeCompleteMatch: _cache[8] || (_cache[8] = ($event: any) => (completeMatch.value = $event))
                  }, null, 8, ["freeWord", "keyData", "keyValue", "completeMatch"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.type === STRUCTUAL)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([_ctx.type === STRUCTUAL ? 'structual-leftarea' : ''])
                }, [
                  _createVNode(StructureSearchForm, {
                    editorFlg: editorFlg.value,
                    "onUpdate:editorFlg": _cache[9] || (_cache[9] = ($event: any) => ((editorFlg).value = $event)),
                    sdfFile: sdfFile.value,
                    "onUpdate:sdfFile": _cache[10] || (_cache[10] = ($event: any) => ((sdfFile).value = $event)),
                    onChangeEditorFlg: _cache[11] || (_cache[11] = ($event: any) => (editorFlg.value = $event)),
                    onChangeSdfFile: _cache[12] || (_cache[12] = ($event: any) => (sdfFile.value = $event))
                  }, null, 8, ["editorFlg", "sdfFile"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.type === STRUCTUAL ? 'structual-rightarea' : 'col-12'])
            }, [
              (_ctx.type === STRUCTUAL)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[29] || (_cache[29] = _createElementVNode("p", { class: "construct-ondition" }, "抽出条件", -1)),
                    _createVNode(StructureConditionsForm, {
                      searchType: searchType.value,
                      "onUpdate:searchType": _cache[13] || (_cache[13] = ($event: any) => ((searchType).value = $event)),
                      ez: ez.value,
                      "onUpdate:ez": _cache[14] || (_cache[14] = ($event: any) => ((ez).value = $event)),
                      chiral: chiral.value,
                      "onUpdate:chiral": _cache[15] || (_cache[15] = ($event: any) => ((chiral).value = $event)),
                      tautomer: tautomer.value,
                      "onUpdate:tautomer": _cache[16] || (_cache[16] = ($event: any) => ((tautomer).value = $event)),
                      threshold: threshold.value,
                      "onUpdate:threshold": _cache[17] || (_cache[17] = ($event: any) => ((threshold).value = $event)),
                      onChangeSearchType: _cache[18] || (_cache[18] = ($event: any) => (searchType.value = $event)),
                      onChangeEz: _cache[19] || (_cache[19] = ($event: any) => (ez.value = $event)),
                      onChangeChiral: _cache[20] || (_cache[20] = ($event: any) => (chiral.value = $event)),
                      onChangeTautomer: _cache[21] || (_cache[21] = ($event: any) => (tautomer.value = $event)),
                      onChangeThreshold: _cache[22] || (_cache[22] = ($event: any) => (threshold.value = $event))
                    }, null, 8, ["searchType", "ez", "chiral", "tautomer", "threshold"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _cache[30] || (_cache[30] = _createElementVNode("p", {
                  class: "q-mb-xs",
                  style: {"font-weight":"600"}
                }, "サプライヤ", -1)),
                _createVNode(SupplierSelectsUseInput, {
                  suppliers: suppliers.value,
                  "onUpdate:suppliers": _cache[23] || (_cache[23] = ($event: any) => ((suppliers).value = $event)),
                  onClear: _cache[24] || (_cache[24] = ($event: any) => (suppliers.value = $event)),
                  onChange: _cache[25] || (_cache[25] = ($event: any) => (suppliers.value = $event))
                }, null, 8, ["suppliers"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.type === KEY)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      color: "primary",
                      style: {"width":"150px"},
                      label: "検索",
                      icon: "mdi-magnify",
                      onClick: keySearch
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === STRUCTUAL)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      color: "primary",
                      style: {"width":"150px"},
                      label: "検索",
                      icon: "mdi-magnify",
                      onClick: structureSearch
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === KEY)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 2,
                      outline: "",
                      style: {"width":"150px","color":"var(--q-delete)"},
                      label: "クリア",
                      icon: "mdi-eraser",
                      onClick: keySearchClear
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === STRUCTUAL)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 3,
                      outline: "",
                      style: {"width":"150px","color":"var(--q-delete)"},
                      label: "クリア",
                      icon: "mdi-eraser",
                      onClick: structureSearchClear
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AlertDialog, {
      display: !searchableFlg.value,
      level: "error",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[27] || (_cache[27] = ($event: any) => (searchableFlg.value = true))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: resultOverFlg.value,
      level: "warning",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: closeDialog
    }, null, 8, ["display", "title", "text"]),
    (searchFlg.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "searchResultElement",
          ref: searchResultElement,
          class: "csr00200-expansion-bar"
        }, [
          _createVNode(_component_q_btn, {
            color: "primary",
            flat: "",
            class: "full-width",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (conditionAreaOpen()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                left: "",
                name: openFlg.value ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down'
              }, null, 8, ["name"])
            ]),
            _: 1
          })
        ], 512))
      : _createCommentVNode("", true),
    (searchFlg.value)
      ? (_openBlock(), _createBlock(SearchResultList, {
          key: 1,
          "search-result": searchResult.value,
          "reagent-flg": reagentFlg.value,
          categories: categories.value,
          suppliers: suppliers.value
        }, null, 8, ["search-result", "reagent-flg", "categories", "suppliers"]))
      : _createCommentVNode("", true)
  ]))
}
}

})